import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { createSelector } from 'reselect';
import OptionNestedPickerModal from '../../editor/components/optionNestedPicker/optionNestedPickerModal';
import entityComposition from '../classes/entityComposition';
import { getContent } from '../../editor/selectors/simpleSelectors';
const reportTagsFromContentSelector = createSelector([getContent], content => content && content.reportTags || {});
const ReportTagsButton = _ref => {
  let change = _ref.reportActions.change,
    _ref$reportID = _ref.reportID,
    reportID = _ref$reportID === void 0 ? null : _ref$reportID,
    serverIndex = _ref.reportTagActions.serverIndex,
    reportTagIndexQuery = _ref.reportTagIndexQuery,
    reportTags = _ref.reportTags,
    values = _ref.values;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const onChange = tree => change(reportID, 'content/reportTags', tree.value);
  const onClose = () => setIsOpen(false);
  const onOpen = () => {
    setIsOpen(true);
    serverIndex(reportTagIndexQuery);
  };
  const options = reportTags.map(rt => {
    const mapTagToOption = tag => {
      const result = {
        identifier: tag.id,
        title: tag.name
      };
      if (tag.nodes && tag.nodes.length > 0) {
        result.options = tag.nodes.map(mapTagToOption);
      }
      return result;
    };
    return mapTagToOption(rt);
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(OptionNestedPickerModal, {
    allowsMultipleSelection: true,
    allowsParentSelection: true,
    allowsOther: false,
    className: "t-onpm-reportTags",
    closeModal: onClose,
    isOpen: isOpen,
    label: "Report Tags",
    onChange: onChange,
    options: options,
    value: values
  }), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "t-report-tags-btn",
    "data-testid": "t-report-tags-btn",
    onClick: onOpen
  }, "Tags"));
};
ReportTagsButton.propTypes = {
  reportActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  reportID: PropTypes.string,
  reportTagActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  reportTagIndexQuery: PropTypes.shape({}).isRequired,
  reportTags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  values: PropTypes.shape({}).isRequired
};
export { ReportTagsButton as UncomposedReportTagsButton };
export default entityComposition(ReportTagsButton, [], {
  reportID: state => state.report.active.id,
  reportTagIndexQuery: state => state.reportTag.indexQuery,
  reportTags: state => state.reportTag.list,
  values: reportTagsFromContentSelector
}, ['report', 'reportTag']);